import React from "react";

export default function ErrorIcon(props) {
  return (
    <svg
      width={props.size || "85"}
      height={props.size || "85"}
      viewBox="0 0 85 85"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.5 0C19.0653 0 0 19.0653 0 42.5C0 65.9347 19.0653 85 42.5 85C65.9347 85 85 65.9347 85 42.5C85 19.0653 65.9347 0 42.5 0ZM42.5 78.9286C22.4134 78.9286 6.07143 62.5866 6.07143 42.5C6.07143 22.4134 22.4134 6.07143 42.5 6.07143C62.5866 6.07143 78.9286 22.4134 78.9286 42.5C78.9286 62.5866 62.5866 78.9286 42.5 78.9286Z"
        fill="#e10c33"
      />
      <path
        d="M55.5238 29.4761C54.3381 28.2905 52.4162 28.2905 51.2306 29.4761L42.4999 38.2068L33.7688 29.4758C32.5832 28.2901 30.6613 28.2901 29.4756 29.4758C28.29 30.6614 28.29 32.5833 29.4756 33.7689L38.2067 42.5L29.4756 51.231C28.29 52.4166 28.29 54.3386 29.4756 55.5242C30.0683 56.1168 30.8454 56.4133 31.6222 56.4133C32.399 56.4133 33.1758 56.1168 33.7688 55.5242L42.4999 46.7932L51.2309 55.5242C51.8236 56.1168 52.6007 56.4133 53.3775 56.4133C54.1543 56.4133 54.9311 56.1168 55.5241 55.5242C56.7097 54.3386 56.7097 52.4166 55.5241 51.231L46.793 42.5L55.5241 33.7689C56.7094 32.5837 56.7094 30.6614 55.5238 29.4761Z"
        fill="#e10c33"
      />
    </svg>
  );
}
